import { render, staticRenderFns } from "./LotTable.vue?vue&type=template&id=24cad14d&scoped=true&"
import script from "./LotTable.vue?vue&type=script&lang=js&"
export * from "./LotTable.vue?vue&type=script&lang=js&"
import style0 from "./LotTable.vue?vue&type=style&index=0&id=24cad14d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cad14d",
  null
  
)

export default component.exports